import { routes } from '@/app/routing/router'
import { TopUpSteamView } from './view'
const currentRoute = routes.topUpSteam

const TopUpSteamRoute = {
  route: currentRoute,
  view: TopUpSteamView,
}

export { currentRoute, TopUpSteamRoute }
